import { $, w } from './constants';

function numberWithCommas(x) {
    x = x.toString();
    return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

$(w).on('load', function () {
    const $amount = $('#ammount_simulator');
    if (!$amount.length) return;

    $amount.on('input', function () {
        let val = this.value;

        // Solo dígitos
        val = val.replace(/[^0-9]/g, '');

        // Si está vacío → limpiar y salir
        if (!val) {
            this.value = '';
            $(this).closest('.input-simulator-field')
                .removeClass('active')
                .addClass('error');
            return;
        }

        // Agregar comas
        const formatted = numberWithCommas(val);

        this.value = formatted;

        // Cambiar estilos
        $(this).closest('.input-simulator-field')
            .addClass('active')
            .removeClass('error');
    });
});